import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c240cba")

_pushScopeId("data-v-4c240cba")
const _hoisted_1 = {
  class: "recommend-item br-lg mr-12 p-8",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "t-l" }
const _hoisted_3 = { class: "df-middle" }
const _hoisted_4 = { class: "c-text f-md ml-4 f-bold" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "t-m flex-1 df-middle df-center" }
const _hoisted_7 = { class: "t-r df-middle" }
const _hoisted_8 = {
  class: "px-8 pt-12 f-md",
  style: {"line-height":"20px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_TheRecommendChart = _resolveComponent("TheRecommendChart")
  const _component_Icon = _resolveComponent("Icon")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_CurrentQuote = _resolveComponent("CurrentQuote")
  const _component_t = _resolveComponent("t")
  const _component_SymbolLink = _resolveComponent("SymbolLink")

  return (_openBlock(), _createBlock(_component_SymbolLink, {
    code: _ctx.item.code
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_CurrentQuote, {
          code: _ctx.item.code
        }, {
          default: _withId(({symbol}) => [
            _createVNode(_component_RealTimeQuote, {
              symbol: symbol,
              onTurn: _ctx.riseTurn
            }, {
              default: _withId(({price, buy, spread, margin, mp, isRise}) => [
                _createVNode("div", {
                  class: ["title-wrap br-lg df-middle px-8", isRise?'bg-s':'bg-d']
                }, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode(_component_Pic, {
                        src: _ctx.item.icon,
                        width: "16",
                        height: "16",
                        style: {"border-radius":"50%"}
                      }, null, 8, ["src"]),
                      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.item.code), 1)
                    ]),
                    _createVNode("p", _hoisted_5, _toDisplayString(price), 1)
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_TheRecommendChart, {
                      code: _ctx.item.code,
                      isRise: isRise,
                      key: _ctx.reLoadDate
                    }, null, 8, ["code", "isRise"])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_Icon, {
                      class: ["p-0 ml-4", {'c-success': isRise, 'c-danger': !isRise}],
                      sm: "",
                      name:  isRise ? 'up': 'down'
                    }, null, 8, ["class", "name"]),
                    _createVNode("p", {
                      class: ["f-nm ml-4", {'c-success': isRise, 'c-danger': !isRise}]
                    }, _toDisplayString(mp), 3)
                  ])
                ], 2)
              ]),
              _: 2
            }, 1032, ["symbol", "onTurn"])
          ]),
          _: 1
        }, 8, ["code"]),
        _createVNode("div", _hoisted_8, [
          _createVNode("p", null, [
            _createVNode("span", {
              class: ["c-white b-o px-8", _ctx.item.tag===_ctx.RecommendTag.BEARISH?'bg-danger':'bg-success']
            }, [
              _createVNode(_component_t, {
                path: _ctx.item.tag===_ctx.RecommendTag.BEARISH?'home_56':'home_55'
              }, null, 8, ["path"])
            ], 2),
            _createTextVNode(" " + _toDisplayString(_ctx.item.advantage), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["code"]))
})